class RecentlyViewedProductsSection extends HTMLElement {
  async connectedCallback() {
    if (this.dataset.loaded === 'true') return;

    let ids = [];
    try {
      ids = JSON.parse(localStorage.getItem('viewedProducts') || '[]');
    } catch {
      this.hidden = true;
      return;
    }

    ids = ids.filter((id) => String(id) !== String(this.dataset.currentProduct)).slice(0, 4);
    if (!ids.length) {
      this.hidden = true;
      return;
    }

    const query = ids.map((id) => `id:${id}`).join(' OR ');
    const url = new URL('/search', window.location.origin);
    url.searchParams.set('section_id', this.dataset.sectionId || '');
    url.searchParams.set('q', query);
    url.searchParams.set('resources[type]', 'product');

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('recent-products-fetch-failed');
      const markup = await response.text();
      const documentFragment = new DOMParser().parseFromString(markup, 'text/html');
      const replacement = documentFragment.querySelector('recently-viewed-products-section');
      if (replacement) this.replaceWith(replacement);
      else this.hidden = true;
    } catch {
      this.hidden = true;
    }
  }
}

if (!customElements.get('recently-viewed-products-section')) {
  customElements.define('recently-viewed-products-section', RecentlyViewedProductsSection);
}
